import { render, staticRenderFns } from "./TopFactorAdSet.vue?vue&type=template&id=2021e20b&"
import script from "./TopFactorAdSet.vue?vue&type=script&lang=ts&"
export * from "./TopFactorAdSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports